import createPagesTranslations from './createPagesTranslations';

export default function createPagesFromResource(data) {
  if (!data) {
    return null;
  }

  return {
    actions: {
      editable: data?.actions?.editable || false,
      archivable: data?.actions?.archivable || false,
      restore: data?.actions?.restore || false,
    },
    isArchived: data.is_archived,
    id: data.pageId,
    mainId: data.id,
    name: data.name,
    panelId: data.panel_id,
    pageId: data.page_id,
    routeName: data.route_name,
    status: data.status,
    translations: createPagesTranslations(data.translations),
  };
}
